import toast from 'react-hot-toast';
import { userFacingError, logQuiet } from './errors';

const baseStyle = {
  borderRadius: '10px',
  padding: '12px 16px',
  fontSize: '14px',
  fontWeight: 500,
  maxWidth: '420px',
  boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
};

export function toastSuccess(message) {
  return toast.success(message, {
    duration: 3500,
    style: {
      ...baseStyle,
      background: '#0f766e',
      color: '#fff',
    },
    iconTheme: { primary: '#fff', secondary: '#0f766e' },
  });
}

export function toastError(errOrMessage, fallback, context = 'action') {
  const message =
    typeof errOrMessage === 'string' && !errOrMessage.includes('Error:')
      ? errOrMessage
      : userFacingError(errOrMessage, fallback);
  if (errOrMessage && typeof errOrMessage !== 'string') {
    logQuiet(context, errOrMessage);
  }
  return toast.error(message, {
    duration: 5000,
    style: {
      ...baseStyle,
      background: '#b91c1c',
      color: '#fff',
    },
    iconTheme: { primary: '#fff', secondary: '#b91c1c' },
  });
}

export function toastInfo(message) {
  return toast(message, {
    duration: 3500,
    style: {
      ...baseStyle,
      background: '#0c2c55',
      color: '#fff',
    },
  });
}
